


































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import storePartograf from "@/store/modules/Partograf";
import { CatatanPersalinan, Kala4Monitoring, KIEItem } from "@/types/partograf";
import { appModule } from "@/store/modules/app";
import http from "@/axios/http-common";

import SectionKala1 from "./catatan/SectionKala1.vue";
import SectionKala2 from "./catatan/SectionKala2.vue";
import SectionKala3 from "./catatan/SectionKala3.vue";
import SectionBayi from "./catatan/SectionBayi.vue";
import SectionKala4 from "./catatan/SectionKala4.vue";
import SectionKie from "./catatan/SectionKie.vue";
import PersonAutoComplete from "@/components/PersonAutoComplete.vue";

const defaultKie: KIEItem[] = [
  { tanggal: null, materi: "seribu_nifas", pelaksana: "", keterangan: "" },
  { tanggal: null, materi: "breast_care", pelaksana: "", keterangan: "" },
  { tanggal: null, materi: "asi", pelaksana: "", keterangan: "" },
  { tanggal: null, materi: "perawatan_tali_pusat", pelaksana: "", keterangan: "" },
  { tanggal: null, materi: "kl", pelaksana: "", keterangan: "" },
  { tanggal: null, materi: "gizi", pelaksana: "", keterangan: "" },
  { tanggal: null, materi: "imunisasi", pelaksana: "", keterangan: "" }
];

@Component({
  components: { SectionKala1, SectionKala2, SectionKala3, SectionBayi, SectionKala4, SectionKie, PersonAutoComplete },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class CardCatatanPersalinan extends Vue {
  @Prop({ default: null }) partografId!: number | string | null;
  @Prop({ type: Object, default: null }) header!: any;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  saving = false;

  tempatOptions = [
    { text: "Rumah Ibu", value: "rumah_ibu" },
    { text: "Puskesmas", value: "puskesmas" },
    { text: "Polindes", value: "polindes" },
    { text: "Rumah Sakit", value: "rumah_sakit" },
    { text: "Klinik Swasta", value: "klinik_swasta" },
    { text: "Lainnya", value: "lainnya" }
  ];

  pendampingMerujukOpts = ["Bidan", "Suami", "Keluarga", "Teman", "Dukun", "Tidak ada"];

  // Penolong persalinan: 2 pilihan terpisah (nama bidan & nama dokter), diambil dari master petugas.
  bidanNames: string[] = [];
  dokterNames: string[] = [];

  form: CatatanPersalinan = {
    info: {
      tanggal: null, penolong: "", penolong_bidan: "", penolong_dokter: "", nama_bidan: "", tempat: "rumah_ibu", alamat_tempat: "",
      rujuk: false, kala_rujuk: null, alasan_merujuk: "", tempat_rujukan: "", pendamping_merujuk: []
    },
    kala_1: { melewati_garis_waspada: null, masalah: "", penatalaksanaan: "", hasilnya: "" },
    kala_2: {
      lama_menit: null,
      episiotomi: null, episiotomi_indikasi: "",
      pendamping: [],
      gawat_janin: null, gawat_janin_tindakan: ["", "", ""],
      distosia_bahu: null, distosia_tindakan: ["", "", ""], distosia_lainnya: "",
      masalah: "", penatalaksanaan: "", hasilnya: ""
    },
    kala_3: {
      lama_menit: null,
      jumlah_perdarahan_ml: null,
      oksitosin_10iu_im_kurang_2menit: null,
      oksitosin_10iu_sisi: "",
      oksitosin_10iu_waktu_menit: null,
      oksitosin_10iu_alasan_tidak: "",
      oksitosin_ulang_2x: null,
      oksitosin_ulang_alasan: "",
      penegangan_tali_pusat: null, penegangan_tali_pusat_alasan: "",
      masase_fundus: null, masase_fundus_alasan: "",
      plasenta_lengkap: null, plasenta_lahir_jam: null, plasenta_tidak_lengkap_tindakan: ["", ""],
      plasenta_tidak_lahir_30mnt: null, plasenta_tidak_lahir_tindakan: ["", "", ""],
      laserasi_ada: null, laserasi_dimana: "",
      laserasi_derajat: null,
      laserasi_tindakan: "", laserasi_alasan_tidak: "",
      atonia_uteri: { kompresi_bimanual: false, metil_ergometrin: false, oksitosin_drip: false },
      atonia_tindakan: ["", "", ""],
      masalah: "", penatalaksanaan: "", hasilnya: ""
    },
    bayi_baru_lahir: {
      bb_gram: null, panjang_cm: null, jenis_kelamin: null,
      apgar_1menit: null, apgar_5menit: null,
      kondisi_saat_lahir: "",
      penilaian: null,
      bayi_lahir_tipe: null,
      tindakan: [], aspiksia_tindakan: [],
      tindakan_lain: "", cacat_bawaan: "",
      hipotermi: false, hipotermi_tindakan: ["", "", ""],
      asi: null, asi_waktu_jam: null, asi_alasan_tidak: "",
      masalah: "", penatalaksanaan: "", hasilnya: ""
    },
    kie: defaultKie
  };

  // Kala IV WHO standard: jam ke-1 observasi tiap 15 menit (4 pengukuran), jam ke-2 tiap 30 menit (2 pengukuran).
  // Suhu hanya diukur tiap 1 jam → row 1 & 5 suhu diisi, row 2/3/4/6 dihitamkan di PDF (cell tidak diukur).
  kala4: Kala4Monitoring = {
    rows: [
      { jam_ke: 1, pukul: null, td_sistole: null, td_diastole: null, nadi: null, suhu: null, tinggi_fundus: "", kontraksi_uterus: "", kandung_kemih: "", perdarahan: "" },
      { jam_ke: 1, pukul: null, td_sistole: null, td_diastole: null, nadi: null, suhu: null, tinggi_fundus: "", kontraksi_uterus: "", kandung_kemih: "", perdarahan: "" },
      { jam_ke: 1, pukul: null, td_sistole: null, td_diastole: null, nadi: null, suhu: null, tinggi_fundus: "", kontraksi_uterus: "", kandung_kemih: "", perdarahan: "" },
      { jam_ke: 1, pukul: null, td_sistole: null, td_diastole: null, nadi: null, suhu: null, tinggi_fundus: "", kontraksi_uterus: "", kandung_kemih: "", perdarahan: "" },
      { jam_ke: 2, pukul: null, td_sistole: null, td_diastole: null, nadi: null, suhu: null, tinggi_fundus: "", kontraksi_uterus: "", kandung_kemih: "", perdarahan: "" },
      { jam_ke: 2, pukul: null, td_sistole: null, td_diastole: null, nadi: null, suhu: null, tinggi_fundus: "", kontraksi_uterus: "", kandung_kemih: "", perdarahan: "" }
    ],
    lama_menit: null,
    masalah: "", penatalaksanaan: "", hasilnya: ""
  };

  mounted() {
    this.loadFromStore();
    this.loadPenolongLists();
  }

  async loadPenolongLists() {
    try {
      const dr = await http.getData("/combo/dokter");
      this.dokterNames = (dr.data || []).map((d: any) => d.nama).filter(Boolean);
    } catch {
      this.dokterNames = [];
    }
    try {
      const bd = await http.getData("/combo/perawat");
      this.bidanNames = (bd.data || []).map((d: any) => d.nama).filter(Boolean);
    } catch {
      this.bidanNames = [];
    }
  }

  @Watch("partografId")
  onIdChange() {
    this.loadFromStore();
  }

  // Kolom "Pukul" Kala IV terisi otomatis dari jam plasenta lahir (Kala III no. 25):
  // jam ke-1 tiap 15 menit, jam ke-2 tiap 30 menit. Baris yang diedit manual tidak ditimpa.
  autoPukul: string[] = [];

  @Watch("form.kala_3.plasenta_lahir_jam")
  onPlasentaJamChange(base: string | null) {
    if (!base || !/^\d{1,2}:\d{2}$/.test(base)) return;
    let offset = 0;
    const computed = this.kala4.rows.map((row) => {
      offset += row.jam_ke === 1 ? 15 : 30;
      return this.addMinutes(base, offset);
    });
    this.kala4.rows.forEach((row, i) => {
      // hanya isi jika kosong atau masih sama dengan hasil auto sebelumnya (bukan editan manual)
      if (!row.pukul || row.pukul === this.autoPukul[i]) {
        row.pukul = computed[i];
      }
    });
    this.autoPukul = computed;
  }

  addMinutes(hhmm: string, mins: number): string {
    const parts = hhmm.split(":");
    let total = Number(parts[0]) * 60 + Number(parts[1]) + mins;
    total = ((total % 1440) + 1440) % 1440;
    const h = Math.floor(total / 60);
    const m = total % 60;
    return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
  }

  loadFromStore() {
    const cur = storePartograf.partograf;
    if (cur && cur.catatan_persalinan) {
      this.form = JSON.parse(JSON.stringify({ ...this.form, ...cur.catatan_persalinan }));
    }
    if (cur && cur.kala4_monitoring) {
      this.kala4 = JSON.parse(JSON.stringify({ ...this.kala4, ...cur.kala4_monitoring }));
    }
  }

  async simpan() {
    if (this.readOnly || this.saving) return;

    this.saving = true;
    try {
      const id = this.partografId || (this.header ? await storePartograf.ensurePartograf(this.header) : null);
      if (!id) {
        appModule.sendErrorAlert("Lembar partograf gagal dibuat. Muat ulang halaman lalu coba lagi.");
        return;
      }

      const res = await storePartograf.saveCatatanPersalinan({
        id,
        catatan_persalinan: this.form,
        kala4_monitoring: this.kala4
      });
      if (res && res.data && res.data.status === 1) {
        appModule.NoticeDelay("Catatan persalinan berhasil disimpan");
        this.$emit("saved");
      }
    } finally {
      this.saving = false;
    }
  }
}
